import { Button, Flex } from "antd";
import { useState } from "react";
import { Link } from "react-router";
import PlusIcon from "../../../../assets/icons/PlusIcon";
import LectureForm from "./LectureForm";

interface LectureComponentProps {
  sectionId: number;
  courseId: number;
}

export default function LectureComponent({
  sectionId,
  courseId,
}: LectureComponentProps) {
  const [isFormVisible, setIsFormVisible] = useState(false);

  const handleAddLecture = () => {
    setIsFormVisible(true);
  };

  const handleFormClose = () => {
    setIsFormVisible(false);
  };

  return (
    <div>
      {/* Lecture Table */}
      {/* Lecture Form */}
      {isFormVisible && (
        <LectureForm
          sectionId={sectionId}
          courseId={courseId}
          onClose={handleFormClose}
        />
      )}

      {!isFormVisible && (
        <Flex align="center" gap={12}>
          <Button
            type="default"
            size="middle"
            className="btn-bordered-primary border border-zinc-200 hover:!border-zinc-200 focus:!border-zinc-200 active:!border-zinc-200 "
            onClick={handleAddLecture}
            icon={<PlusIcon className="text-lg" />}
          >
            Add Lecture
          </Button>
          <Link
            to={`/admin/my-course/manage-course/manage-quiz/${courseId}/${sectionId}`}
          >
            <Button
              type="default"
              size="middle"
              className="btn-bordered-primary border border-zinc-200 hover:!border-zinc-200 focus:!border-zinc-200 active:!border-zinc-200"
              onClick={handleAddLecture}
              icon={<PlusIcon className="text-lg" />}
            >
              Add Quiz
            </Button>
          </Link>
        </Flex>
      )}
    </div>
  );
}
